import { gql } from '@apollo/client';

export const CREATE_CARE_TEAM = gql`
mutation($record : CareTeamCreateInput!)
  {orgUnit
    {createCareTeam(record: $record)
      {
        ok,
        error{
          message
        },
        resultId,
        result{
          id,
          subOrganizations{
            id,
            name
          },
          name,
          practitioners{
            id,
            firstName,
            lastName
          }
        }
      }
    }
  }
`;
